module.exports = __webpack_public_path__ + "static/media/user-lock-2.f61093d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/backgrounds/user-lock-2.svg
// module id = 501
// module chunks = 0